import storage from './storage';

export type SupportedLocale = 'en' | 'id';

const get = (json: Record<string, any>, key: string): string | undefined => {
  if (!json) return undefined;
  return json[key];
};

export const translator = (
  locale: SupportedLocale,
  key: string,
): string | undefined => {
  const idFile = storage.get('idFortune');
  const enFile = storage.get('enFortune');

  switch (locale) {
    case 'id':
      return get(idFile, key);
    default:
      return get(enFile, key);
  }
};

export const getTranslation = (
  locale: SupportedLocale,
  key: string | null | undefined,
): string | undefined => {
  if (key === null || key === undefined || key == '') return ``;

  const result = translator(locale, key);
  const app = storage.get('app');
  if (result === undefined) {
    // eslint-disable-next-line no-console
    if (app !== 'payportal')
      console.error(`UI Desktop Translation with ${key} key not found`);

    //  fallback to the key without underscore
    return translator('en', key);
  }

  return result;
};
